import { render } from "./liveIcon.vue?vue&type=template&id=4f600d1c&scoped=true"
import script from "./liveIcon.vue?vue&type=script&lang=js"
export * from "./liveIcon.vue?vue&type=script&lang=js"

import "./liveIcon.vue?vue&type=style&index=0&id=4f600d1c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f600d1c"]])

export default __exports__